import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ✅ GET: Traer todos los empleados
export const getEmpleados = async () => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/empleados`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener empleados",
    };
  }
};

// ✅ GET: Traer un empleado por ID
export const getEmpleadoById = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/empleados/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener empleado",
    };
  }
};

// ✅ POST: Crear nuevo empleado
export const postEmpleado = async (empleadoData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/empleados`;

  try {
    const resp = await axios.post(url, empleadoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear empleado",
    };
  }
};

// ✅ PUT: Actualizar empleado
export const putEmpleado = async (id, empleadoData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/empleados/${id}`;

  try {
    const resp = await axios.put(url, empleadoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar empleado",
    };
  }
};

// ✅ DELETE: Desactivar empleado
export const deleteEmpleado = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/empleados/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar empleado",
    };
  }
};